// extracted by mini-css-extract-plugin
module.exports = {"separator":"LineSeparator_separator__8_onG","separatorText":"LineSeparator_separatorText__zjypC","line":"LineSeparator_line__KowFW"};